import * as Types from "@clockwise/schema";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type BookingDetailsQueryQueryVariables = Types.Exact<{
  bookingId: Types.Scalars["String"];
  timeZone: Types.Scalars["String"];
  startDate: Types.Scalars["String"];
  endDate: Types.Scalars["String"];
}>;

export type BookingDetailsQueryQuery = {
  __typename: "Query";
  viewer: {
    __typename: "Viewer";
    user: {
      __typename: "User";
      id: string;
      emails: Array<string>;
      linkNameErrorable:
        | {
            __typename: "GraphEntityError";
            message: string | null;
            statusCode: number | null;
            body: string | null;
          }
        | { __typename: "LinkName"; linkName: string | null }
        | null;
    } | null;
    schedulingLinkBooking:
      | {
          __typename: "GraphEntityError";
          statusCode: number | null;
          message: string | null;
          body: string | null;
        }
      | {
          __typename: "PublicBooking";
          id: string;
          startTime: string;
          endTime: string;
          ownerEmail: string;
          attendeeEmail: string;
          locationType: Types.BookingLocationType;
          meetingName: string;
          description: string | null;
          ownerProfile: {
            __typename: "UserProfile";
            givenName: string | null;
            familyName: string | null;
            externalImageUrl: string | null;
          };
          schedulingLinkDetails: {
            __typename: "SchedulingLinkDetails";
            linkName: string;
            slug: string;
            ownerProfile: {
              __typename: "UserProfile";
              givenName: string | null;
              familyName: string | null;
              externalImageUrl: string | null;
            };
            publicMeetingSettings: {
              __typename: "PublicMeetingSettings";
              id: string;
              locationType: Types.PublicLinkLocationType;
              name: string;
              description: string | null;
              durationMinutes: number;
              highlightBestTimes: boolean;
              endOfAvailability: { __typename: "EventTime"; dateOrDateTime: string };
            };
            suggestedSlotsByDate: Array<{
              __typename: "SuggestedSlotsByDate";
              date: string;
              suggestedSlots: Array<{
                __typename: "SuggestedSlot";
                tag: Types.Tag | null;
                timeRange: {
                  __typename: "TimeRangeNonNull";
                  startTime: {
                    __typename: "EventTime";
                    type: Types.EventTimeType;
                    dateOrDateTime: string;
                    timeZone: string | null;
                    millis: number;
                    offsetMinutes: number | null;
                  };
                  endTime: {
                    __typename: "EventTime";
                    type: Types.EventTimeType;
                    dateOrDateTime: string;
                    timeZone: string | null;
                    millis: number;
                    offsetMinutes: number | null;
                  };
                };
              }>;
            }>;
          } | null;
        }
      | null;
  };
};

export type RescheduleBookingMutationVariables = Types.Exact<{
  bookingId: Types.Scalars["ID"];
  startTime: Types.Scalars["String"];
  endTime: Types.Scalars["String"];
  reason?: Types.InputMaybe<Types.Scalars["String"]>;
}>;

export type RescheduleBookingMutation = {
  __typename: "Mutation";
  rescheduleBooking: {
    __typename: "RescheduleBookingMutationPayload";
    clientMutationId: string | null;
  } | null;
};

export const BookingDetailsQueryDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "BookingDetailsQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "bookingId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "timeZone" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "startDate" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "endDate" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "emails" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "linkNameErrorable" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "LinkName" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "linkName" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "GraphEntityError" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "message" } },
                                  { kind: "Field", name: { kind: "Name", value: "statusCode" } },
                                  { kind: "Field", name: { kind: "Name", value: "body" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "schedulingLinkBooking" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "bookingId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "bookingId" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "PublicBooking" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "startTime" } },
                            { kind: "Field", name: { kind: "Name", value: "endTime" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ownerProfile" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "givenName" } },
                                  { kind: "Field", name: { kind: "Name", value: "familyName" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "externalImageUrl" },
                                  },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "ownerEmail" } },
                            { kind: "Field", name: { kind: "Name", value: "attendeeEmail" } },
                            { kind: "Field", name: { kind: "Name", value: "locationType" } },
                            { kind: "Field", name: { kind: "Name", value: "meetingName" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "schedulingLinkDetails" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "timeZone" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "timeZone" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "startDate" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "startDate" },
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "endDate" },
                                  value: {
                                    kind: "Variable",
                                    name: { kind: "Name", value: "endDate" },
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "linkName" } },
                                  { kind: "Field", name: { kind: "Name", value: "slug" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "ownerProfile" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "givenName" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "familyName" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "externalImageUrl" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "publicMeetingSettings" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "locationType" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "description" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "durationMinutes" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "highlightBestTimes" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "endOfAvailability" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "dateOrDateTime" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "suggestedSlotsByDate" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "date" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "suggestedSlots" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "timeRange" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "startTime" },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "type" },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "dateOrDateTime",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "timeZone",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "millis" },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "offsetMinutes",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "endTime" },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "type" },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "dateOrDateTime",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "timeZone",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "millis" },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "offsetMinutes",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "tag" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "GraphEntityError" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "statusCode" } },
                            { kind: "Field", name: { kind: "Name", value: "message" } },
                            { kind: "Field", name: { kind: "Name", value: "body" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<BookingDetailsQueryQuery, BookingDetailsQueryQueryVariables>;
export const RescheduleBookingDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RescheduleBooking" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "bookingId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "startTime" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "endTime" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "reason" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rescheduleBooking" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "bookingId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "bookingId" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "body" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eventStartTime" },
                            value: { kind: "Variable", name: { kind: "Name", value: "startTime" } },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eventEndTime" },
                            value: { kind: "Variable", name: { kind: "Name", value: "endTime" } },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "reasonForReschedule" },
                            value: { kind: "Variable", name: { kind: "Name", value: "reason" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "clientMutationId" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<RescheduleBookingMutation, RescheduleBookingMutationVariables>;
